import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { installViewAsSession } from './utils/viewAsSession';
import reportWebVitals from './reportWebVitals';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

// Must run before anything reads the login token ("view as technician" tabs)
installViewAsSession();

const theme = createTheme();

const rootElement = document.getElementById('root');

// --- START RESIZEOBSERVER    SUPPRESSION ---
const originalError = console.error;
console.error = (...args) => {
  let isResizeObserverError = false;
  if (args[0] && typeof args[0] === 'string' && args[0].includes('ResizeObserver loop completed with undelivered notifications')) {
    isResizeObserverError = true;
  } else if (args[0] instanceof Error && args[0].message.includes('ResizeObserver loop completed with undelivered notifications')) {
    isResizeObserverError = true;
  }

  if (isResizeObserverError) {
    return;
  }
  originalError.apply(console, args);
};
// --- END RESIZEOBSERVER SUPPRESSION ---

const appTree = (
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <App />
      </LocalizationProvider>
    </ThemeProvider>
  </React.StrictMode>
);

// Prerendered SEO pages ship real markup inside #root → hydrate it. The plain
// SPA shell only contains a "booting…" text node (no element child) → mount
// fresh. Guard on firstElementChild, NOT hasChildNodes(), because the text
// placeholder would falsely trigger hydration.
if (rootElement.firstElementChild) {
  ReactDOM.hydrateRoot(rootElement, appTree);
} else {
  ReactDOM.createRoot(rootElement).render(appTree);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to a analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(); 